import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultToolResource,
    ToolMutationResourceSchema,
    useToolActions,
} from '../../../../../resource/resources/artifacts/tool/toolResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ToolContent } from './ToolContent';

export const ToolEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const toolActions = useToolActions();
    const toolQuery = toolActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateTool = toolActions.useUpdateResource();
    const validation = toolActions.useValidateResource(toolQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ToolMutationResourceSchema,
        defaultValues: defaultToolResource,
        submitHandler: async (data) => {
            await updateTool.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: toolQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Tool'}
            resourceType={ResourceType.TOOL}
            resourceValidationResult={validation.data}
            metaDataInfo={toolQuery.data}
        >
            <QueryBaseComponent name="Tool" query={toolQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <ToolContent form={form} formNames={formNames} readOnly={readOnly} id={toolQuery.data?.id} />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
